const DB_NAME = 'eili_bible_offline';
const DB_VERSION = 2;
const STORE_NAME = 'passages';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      // Delete old store to clear stale cached verses
      if (db.objectStoreNames.contains(STORE_NAME)) {
        db.deleteObjectStore(STORE_NAME);
      }
      db.createObjectStore(STORE_NAME, { keyPath: 'key' });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Entries cached before this date are considered stale and will be re-fetched
const CACHE_EPOCH = 1742300000000; // March 18, 2026 - cache reset date

export async function getCachedPassage(reference, translation) {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const key = `${translation}|${reference.toLowerCase()}`;
    return new Promise((resolve) => {
      const req = store.get(key);
      req.onsuccess = () => {
        const entry = req.result;
        // Ignore entries cached before the reset epoch
        if (entry && entry.timestamp && entry.timestamp < CACHE_EPOCH) {
          resolve(null);
          return;
        }
        resolve(entry?.data || null);
      };
      req.onerror = () => resolve(null);
    });
  } catch {
    return null;
  }
}

export async function cachePassage(reference, translation, data) {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const key = `${translation}|${reference.toLowerCase()}`;
    store.put({ key, data, translation, reference: reference.toLowerCase(), timestamp: Date.now() });
  } catch { /* storage full */ }
}

export async function bulkCachePassages(entries) {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    for (const { reference, translation, data } of entries) {
      const key = `${translation}|${reference.toLowerCase()}`;
      store.put({ key, data, translation, reference: reference.toLowerCase(), timestamp: Date.now() });
    }
    return new Promise((resolve) => {
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => resolve(false);
    });
  } catch {
    return false;
  }
}

export async function getDownloadedTranslations() {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    return new Promise((resolve) => {
      const req = store.getAll();
      req.onsuccess = () => {
        const counts = {};
        for (const item of req.result) {
          const t = item.translation;
          counts[t] = (counts[t] || 0) + 1;
        }
        resolve(counts);
      };
      req.onerror = () => resolve({});
    });
  } catch {
    return {};
  }
}

export async function deleteTranslationCache(translation) {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    return new Promise((resolve) => {
      const req = store.getAll();
      req.onsuccess = () => {
        for (const item of req.result) {
          if (item.translation === translation) {
            store.delete(item.key);
          }
        }
        resolve(true);
      };
      req.onerror = () => resolve(false);
    });
  } catch {
    return false;
  }
}

// Total chapters in the Bible: 1189
export const TOTAL_BIBLE_CHAPTERS = 1189;
